import { api } from './client'

// ---------- Types ----------

export interface AuditLogEntry {
  id: string
  actor_id: string
  actor_name: string
  actor_email: string
  action: string
  target_type: string
  target_id: string
  details: Record<string, unknown>
  created_at: string
}

export interface AuditLogResponse {
  items: AuditLogEntry[]
  total: number
  page: number
  per_page: number
}

export type AuditAction =
  | 'org.created'
  | 'org.updated'
  | 'user.provisioned'
  | 'user.deactivated'
  | 'user.reactivated'
  | 'user.role_changed'

export const AUDIT_ACTIONS: { value: AuditAction; label: string }[] = [
  { value: 'org.created', label: 'Org Created' },
  { value: 'org.updated', label: 'Org Updated' },
  { value: 'user.provisioned', label: 'User Provisioned' },
  { value: 'user.deactivated', label: 'User Deactivated' },
  { value: 'user.reactivated', label: 'User Reactivated' },
  { value: 'user.role_changed', label: 'Role Changed' },
]

export interface AuditParams {
  action?: AuditAction
  start_date?: string // ISO date YYYY-MM-DD
  end_date?: string // ISO date YYYY-MM-DD
  page: number
  per_page?: number
}

// ---------- API ----------

export async function fetchAuditLogs(
  params: AuditParams
): Promise<AuditLogResponse> {
  const searchParams = new URLSearchParams()
  if (params.action) searchParams.set('action', params.action)
  if (params.start_date) searchParams.set('start_date', params.start_date)
  if (params.end_date) searchParams.set('end_date', params.end_date)
  searchParams.set('page', String(params.page))
  if (params.per_page) searchParams.set('per_page', String(params.per_page))
  return api.get<AuditLogResponse>(
    `/api/v1/admin/audit?${searchParams.toString()}`
  )
}
